type FirebaseErrorLike = {
  readonly code?: unknown;
  readonly message?: unknown;
};

export function authErrorMessage(error: unknown, fallback: string): string {
  if (isCancelledAuthRequest(error)) {
    return "Google sign-in was canceled. Try again when you are ready.";
  }
  return error instanceof Error ? error.message : fallback;
}

export function isCancelledAuthRequest(error: unknown): boolean {
  if (!isRecord(error)) return false;
  const { code, message } = error as FirebaseErrorLike;
  return code === "auth/cancelled-popup-request" ||
    code === "auth/popup-closed-by-user" ||
    (typeof message === "string" && (
      message.includes("auth/cancelled-popup-request") ||
      message.includes("auth/popup-closed-by-user")
    ));
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
